/**
 * Kolory statusów płatności - jedno miejsce dla całej aplikacji.
 *
 * Ta sama drabinka `cn()` siedziała w czterech tabelach naraz i za każdym
 * razem trochę inna: jedna nie znała "Oczekuje", inna "Na bieżąco". Status
 * bez trafienia dostawał sam `text-white` bez tła, czyli biały napis na białym
 * - znikał z ekranu zamiast rzucić się w oczy. Stąd jedna mapa i jawny kolor
 * domyślny.
 *
 * Skala jest celowo prosta: czerwony to pieniądze, których nie ma, zielony to
 * pieniądze, które są, pomarańczowy to stan przejściowy, szary to jeszcze nie
 * nasza kolej.
 */
import { cn } from './utils';

const PODSTAWA = 'text-[11px] p-1 text-center rounded-[4px] inline-block';

/** Status -> klasy tła i tekstu. */
const KOLORY = {
  'Zapłacono': 'text-white bg-[#5CC184]',
  'Na bieżąco': 'text-white bg-[#6BA8D6]',
  'Do zapłaty': 'text-white bg-[#BEBEBE]',
  'Oczekuje': 'text-white bg-[#D1D5DB]',
  'Po terminie': 'text-white bg-[#E99B67]',
  'Niepełna wpłata': 'text-white bg-[#E99B67]',
  'Windykacja': 'text-white bg-[#C15C5C]',
  // Nie jest to stan płatności, tylko przyznanie się do niewiedzy: lokal nie
  // ma numeru rachunku, więc żadna wpłata nie ma jak się do niego dopiąć.
  // Dlatego jako jedyny nie jest wypełniony kolorem - obwódka mówi "brak
  // informacji", a nie "jeszcze jeden rodzaj zaległości".
  'Brak danych': 'text-[#6B7280] bg-white border border-dashed border-[#9CA3AF]',
};

/** Kolor nieznanego statusu. Ma być widoczny, a nie zlewać się z tłem. */
const DOMYSLNY = 'text-[#4B5563] bg-[#F3F4F6] border border-[#E5E7EB]';

/** Pełny zestaw klas dla plakietki statusu. */
export function klasaStatusu(status, dodatkowe) {
  return cn(PODSTAWA, KOLORY[status] || DOMYSLNY, dodatkowe);
}

/** Statusy do list wyboru, w kolejności od "zapłacone" do "problem". */
export const STATUSY_PLATNOSCI = [
  'Zapłacono',
  'Na bieżąco',
  'Do zapłaty',
  'Po terminie',
  'Niepełna wpłata',
  'Windykacja',
  'Brak danych',
];
